import { PppServerConstants } from "../constants/pppserver.constants";

const PppServerReducer = (state, action) => {
  switch (action.type) {
    case PppServerConstants.FETCH_PPP_SERVER_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PppServerConstants.FETCH_PPP_SERVER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pppServers: action.payload.data,
        paging: action.payload.paging,
      };
    case PppServerConstants.FETCH_PPP_SERVER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PppServerConstants.PPP_SERVER_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PppServerConstants.PPP_SERVER_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pppServerSearchResults: action.payload,
      };
    case PppServerConstants.PPP_SERVER_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PppServerConstants.PPP_SERVER_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PppServerConstants.PPP_SERVER_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pppServerAutoSearchResults: action.payload,
      };
    case PppServerConstants.PPP_SERVER_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PppServerConstants.ADD_PPP_SERVER_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case PppServerConstants.ADD_PPP_SERVER_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case PppServerConstants.ADD_PPP_SERVER_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case PppServerConstants.GET_PPP_SERVER_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PppServerConstants.GET_PPP_SERVER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pppServer: action.payload,
      };
    case PppServerConstants.GET_PPP_SERVER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PppServerConstants.UPDATE_PPP_SERVER_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case PppServerConstants.UPDATE_PPP_SERVER_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        pppServer: action.payload,
      };
    case PppServerConstants.UPDATE_PPP_SERVER_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };
    case PppServerConstants.DOWNLOAD_PPP_SERVER_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case PppServerConstants.DOWNLOAD_PPP_SERVER_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case PppServerConstants.DOWNLOAD_PPP_SERVER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case PppServerConstants.UPLOAD_PPP_SERVER_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case PppServerConstants.UPLOAD_PPP_SERVER_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case PppServerConstants.UPLOAD_PPP_SERVER_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };

    default:
      return state;
  }
};

export default PppServerReducer;
